import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class StatusService {
    // Get All 
    static async getAllStatuses(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.STATUSES; // endpoint
        const requestModel = { storeId };
        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        } else {
            console.error('Failed to fetch statuses.');
            return [];
        }
    }

    // Create 
    static async addNewStatus(data) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.STATUSES; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Status added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new status.');
        }
    }

    // Get by ID
    static async getStatusById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.STATUSES}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch status by ID');
        }
    }

    // Update 
    static async updateStatusById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.STATUSES}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Status updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update status.');
        }
    }

    // Delete 
    static async deleteStatus(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.STATUSES}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete status.');
            }
        } catch (error) {
            console.error('Error deleting status:', error);
            throw error;
        }
    }

    // Delete Many 
    static async deleteManyStatuses(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.STATUSES}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }

    static async getStatusByType(statustype) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.STATUSES}/type/${statustype}`;

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
